import { MenuItem } from 'vue-graphql-models';

export default [
  new MenuItem({
    id: 'setHomePage',
    title: 'Set Home Page',
    subtitle: 'Set This Screen as Home Page.',
    icon: 'settings',
  }),
  new MenuItem({
    id: 'uploadLabTest',
    title: 'Upload Lab Test',
    subtitle: 'Upload Lab Test for Asset.',
    icon: 'cloud_upload',
  }),
];
